import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import dsteem from "../unit/DsteemUtil";
import { toDecimal } from "../unit/public";
import { getAccount, extractLoginData } from "../unit/UserUtil";
export default {
  name: "Login",
  props: ["isHaveKeychain", "isShowModelDelegate", "ruleForm"],
  emits: ["update:isShowModel"],
  data: function data() {
    return {
      isUseSteemKeychain: false,
      acitveKey: "",
      isLogin: false,
      isLoginError: false,
      errorMessage: "",
      rememberMe: false,
      loginResult: null,
      isLogining: false,
      loading: null,
      showLoginModel: false,
      fromUser: ""
    };
  },
  watch: {
    isShowModelDelegate: function isShowModelDelegate(newVal) {
      this.showLoginModel = newVal;
    },
    showLoginModel: function showLoginModel(newVal) {
      this.$emit("update:isShowModelDelegate", newVal);
    }
  },
  methods: {
    comfirmTran: function comfirmTran() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var props, avail, op, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.acitveKey) {
                  _context.next = 4;
                  break;
                }

                _this.errorMessage = "activeKeyError";
                _this.isLoginError = true;
                return _context.abrupt("return");

              case 4:
                _this.isLogining = true;
                _context.next = 7;
                return dsteem.getDynamicGlobalProperties();

              case 7:
                props = _context.sent;
                //计算出 SP对应的vesting
                avail = parseFloat(_this.ruleForm.transferAmount / parseFloat(props.total_vesting_fund_steem) * parseFloat(props.total_vesting_shares), 6).toFixed(6) + " VESTS";
                op = ["delegate_vesting_shares", {
                  delegator: _this.fromUser,
                  delegatee: _this.ruleForm.toUser,
                  vesting_shares: avail
                }];
                _context.prev = 10;
                _context.next = 13;
                return dsteem.sendOperations([op], _this.acitveKey);

              case 13:
                result = _context.sent;

                if (result) {
                  _this.isLoginError = false;
                  _this.errorMessage = "";
                  _this.isLogining = false;

                  _this.$emit("comfirmTran");
                }

                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](10);

                if (_context.t0.jse_info.code == 10) {
                  _this.isLoginError = true;
                  _this.errorMessage = "balanceError";
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                } //


              case 20:
                /*  if (this.loginResult.code == 0) {
                        this.$emit("comfirmTran");
                } else {
                  this.isLoginError = true;
                  if (this.loginResult.code == -1)
                    this.errorMessage = "userOrPasswordError";
                  else this.errorMessage = "systemError";
                }
                */
                _this.isLogining = false;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 17]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loginData = extractLoginData();

              if (_this2.loginData) {
                _this2.fromUser = _this2.loginData[0];
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};